function clean(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}

function serialize(obj, prefix) {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + '[' + p + ']' : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? serialize(v, k)
          : encodeURIComponent(k) + '=' + encodeURIComponent(v),
      );
    }
  }
  return str.join('&');
}

function search() {
  // Google search places
  var places_options = {
    componentRestrictions: {
      country: 'au',
    },
  };

  var input = document.getElementById('searchPlaces');
  var inputMobile = document.getElementById('searchPlacesMobile');
  var inputBlock = document.getElementById('searchPlacesBlock');
  var inputQuery = document.getElementById('searchPlacesQuery');

  var autocomplete = new google.maps.places.Autocomplete(input, places_options);
  var autocompleteMobile = new google.maps.places.Autocomplete(
    inputMobile,
    places_options,
  );
  var autocompleteBlock = new google.maps.places.Autocomplete(
    inputBlock,
    places_options,
  );
  var autocompleteQuery = new google.maps.places.Autocomplete(
    inputQuery,
    places_options,
  );

  $('.search-field-form').submit(function (e) {
    e.preventDefault();
  });

  google.maps.event.addListener(autocomplete, 'place_changed', function () {
    lookupSubmit(autocomplete);
  });

  google.maps.event.addListener(
    autocompleteMobile,
    'place_changed',
    function () {
      lookupSubmit(autocompleteMobile);
    },
  );

  google.maps.event.addListener(
    autocompleteBlock,
    'place_changed',
    function () {
      lookupSubmit(autocompleteBlock);
    },
  );

  google.maps.event.addListener(
    autocompleteQuery,
    'place_changed',
    function () {
      const place = autocompleteQuery.getPlace();
      const address = place['address_components'];
      if (address) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        fillValue('searchPlacesQuery--lat', lat);
        fillValue('searchPlacesQuery--lng', lng);

        for (const component of place.address_components) {
          const componentType = component.types[0];
          switch (componentType) {
            case 'street_number':
              fillValue('searchPlacesQuery--streetNumber', component.long_name);
              break;
            case 'route':
              fillValue('searchPlacesQuery--streetName', component.short_name);
              break;
            case 'postal_code': {
              fillValue('searchPlacesQuery--postcode', component.long_name);
              break;
            }
            case 'locality':
              fillValue('searchPlacesQuery--locality', component.long_name);
              break;
            case 'administrative_area_level_1':
              fillValue('searchPlacesQuery--state', component.long_name);
              fillValue('searchPlacesQuery--stateAbbr', component.short_name);
              break;
            case 'country':
              fillValue('searchPlacesQuery--country', component.long_name);
              fillValue('searchPlacesQuery--countryCode', component.short_name);
              break;
          }
        }
      }
    },
  );

  function lookupSubmit(autocomplete) {
    var lat, lng, postcode;

    var place = autocomplete.getPlace();
    const address = place['address_components'];

    if (address) {
      postcode = address[address.length - 1].long_name;
      lat = place.geometry.location.lat();
      lng = place.geometry.location.lng();
    }
    var formInput = input || inputMobile;
    window.location.href =
      '/properties?' +
      serialize(
        clean({
          search: formInput.value,
          lat: lat,
          lng: lng,
          postcode: postcode,
        }),
      );
  }

  function fillValue(componentId, value) {
    const component = document.getElementById(componentId);
    if (component) {
      component.value = value;
    }
  }
}

jQuery(document).ready(function ($) {
  // document.addEventListener("turbolinks:load", function() {
  search();
  // });
});
